const CustomTooltip = ({ active, payload, label, formatter }) => {
  if (!active || !payload?.length) return null;

  return (
    <div className="bg-slate-800 text-slate-50 px-3 py-2.5 rounded-lg shadow-lg text-xs border-0">
      {label && <p className="font-medium mb-1.5 text-slate-300">{label}</p>}
      <div className="space-y-1">
        {payload.map((entry, i) => (
          <p key={i} className="flex items-center gap-2">
            <span
              className="w-2 h-2 rounded-full flex-shrink-0"
              style={{ backgroundColor: entry.color }}
            />
            <span className="text-slate-400">{entry.name}:</span>
            <span className="font-semibold ml-auto">
              {formatter ? formatter(entry.value, entry.name) : entry.value?.toLocaleString()}
            </span>
          </p>
        ))}
      </div>
    </div>
  );
};

export default CustomTooltip;
